module.exports = __webpack_public_path__ + "img/mot.338b3082.jpg";